import { render, staticRenderFns } from "./activationStatisticsList.vue?vue&type=template&id=5d3cad72&scoped=true&"
import script from "./activationStatisticsList.vue?vue&type=script&lang=js&"
export * from "./activationStatisticsList.vue?vue&type=script&lang=js&"
import style0 from "./activationStatisticsList.vue?vue&type=style&index=0&id=5d3cad72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3cad72",
  null
  
)

export default component.exports